import { useState } from "react"
import cn from "classnames"
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel"
import Image from "components/Image"
import Arrow from "public/assets/right-arrow.svg"
import useWindowSize from "utilities/useWindowSize"

export default function InlineImageGallery({ blok }) {
  const width = useWindowSize().width
  const [selectedImg, setSelectedImg] = useState(0)

  const buttonStyles = "mx-0 pt-0 absolute top-1/2 -translate-y-1/2"

  const moveRight = () => (selectedImg < blok.images.length - 1 ? setSelectedImg(selectedImg + 1) : setSelectedImg(0))

  const moveLeft = () => (selectedImg !== 0 ? setSelectedImg(selectedImg - 1) : setSelectedImg(blok.images.length - 1))

  return (
    <div className="mx-auto max-w-screen-xl relative py-8 first:pt-0">
      <div className="flex flex-col lg:flex-row">
        <div className="">
          <div
            className={cn(
              "mb-6 w-full lg:w-[800px] h-[280px] sm:h-[500px] mx-auto overflow-hidden relative rounded-br-4xl",
            )}
          >
            <Image
              src={blok.images[selectedImg].filename}
              alt={blok.images[selectedImg].alt}
              placeholder={blok.images[selectedImg]?.blurDataURL ? "blur" : "empty"}
              blurDataURL={blok.images[selectedImg]?.blurDataURL}
              fill
              className="gallery-image"
            />
          </div>

          <CarouselProvider
            isIntrinsicHeight
            totalSlides={blok.images.length}
            visibleSlides={width > 750 ? 5 : 2}
            infinite
            currentSlide={selectedImg}
            className="sm:mx-auto relative"
          >
            <Slider className="md:w-full w-3/4 max-w-[150px] min-[450px]:max-w-[300px] md:max-w-[600px] lg:max-w-[700px] mx-auto overflow-hidden">
              {blok.images.map((photo, i) => (
                <Slide key={i} index={i} className="px-1 lg:px-2">
                  <button onClick={() => setSelectedImg(blok.images.indexOf(photo))} aria-label="Image Thumbnail">
                    <Image
                      placeholder={photo.image?.blurDataURL ? "blur" : "empty"}
                      blurDataURL={photo.image?.blurDataURL}
                      src={photo.filename}
                      alt={photo.alt}
                      width={131}
                      height={74}
                      sizes="8vw"
                      className="aspect-[1.7] object-cover"
                    />
                  </button>
                </Slide>
              ))}
            </Slider>
            <div>
              <ButtonBack className={cn(buttonStyles, "left-2 lg:left-0")} onClick={() => moveLeft()}>
                <Arrow className="rotate-180 text-secondary hover:text-tertiary" />
              </ButtonBack>
              <ButtonNext className={cn(buttonStyles, "right-2 lg:right-0")} onClick={() => moveRight()}>
                <Arrow className="text-secondary hover:text-tertiary" />
              </ButtonNext>
            </div>
          </CarouselProvider>
        </div>
      </div>
    </div>
  )
}
